// extracted by mini-css-extract-plugin
var _1 = "Result_buttonTry__fbc05";
var _2 = "Result_count__9900e";
var _3 = "Result_progress__33cb4";
var _4 = "Result_root__c8e58";
var _5 = "Result_textTry__0ac7d";
var _6 = "Result_tryAgain__fa56c";
export { _1 as "buttonTry", _2 as "count", _3 as "progress", _4 as "root", _5 as "textTry", _6 as "tryAgain" }
